export default __webpack_public_path__ + "assets/img/tyre-placeholder.fbd8437d.png";